import { ReadonlyVec } from "./readonly";
import { triangulatePoints } from "../triangulate";
import { median } from "./statistics";

export namespace pointSet{
	export function matchXY<T>(setA:T[], setB:T[], toPoint:(v:T)=>ReadonlyVec){
		let possiblities:{a:T,b:T,dist:number}[]=[];

		for(const a of setA){
			const pa=toPoint(a);
			for(const b of setB){
				if(a!==b){
					const pb=toPoint(b);
					possiblities.push({a,b,dist:pa.distToXY(pb)});
				}
			}
		}
		possiblities.sort((a,b)=>b.dist-a.dist);

		const pairs=new Map<T,T>();
		while(possiblities.length>0){
			const pair=possiblities.pop()!;
			pairs.set(pair.a,pair.b);
			pairs.set(pair.b,pair.a);
			possiblities=possiblities.filter(v=>v.a!==pair.a && v.a!==pair.b && v.b!==pair.a && v.b!==pair.b);
		}
		return pairs;
	}

	export function medianDistXY<T>(items:T[], toPoint:(v:T)=>ReadonlyVec){
		const points=items.map(toPoint);
		const triangulated=triangulatePoints(points);
		const dists=triangulated.connections().map(([a,b])=>points[a].distToXY(points[b]));
		return median(dists);
	}
}
